export default __webpack_public_path__ + "static/media/eye-active-icon.4d2eb9c5.svg";